import React from 'react'
import { HERITAGE_BLUE_RADIAL } from '../constants/interaxColors'

export interface InnerBoxProps {
  children: React.ReactNode
  className?: string
}

/**
 * InnerBox Component
 *
 * A container component with Heritage Blue radial gradient background and white 4% border.
 * Used for creating inner content containers with a subtle radial gradient effect.
 *
 * @param children - Content to be rendered inside the box
 * @param className - Additional CSS classes to apply
 */
export const InnerBox: React.FC<InnerBoxProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`
        border border-white-20 
        rounded-lg 
        px-6 pt-6 pb-4
        ${className}
      `}
      style={{
        background: HERITAGE_BLUE_RADIAL
      }}
    >
      {children}
    </div>
  )
}

export default InnerBox
